import { LocaleEnum } from '@systemeio/ui'

export const getDomainHelpLink = (locale?: LocaleEnum) => {
  switch (locale) {
    case LocaleEnum.FRENCH: {
      return 'https://aide.systeme.io/article/2141-comment-definir-le-type-de-comportement-qui-donne-acces-aux-ressources-de-vos-offres-lorsque-les-clients-achetent-un-abonnement'
    }
    default: {
      return 'https://help.systeme.io/article/2145-how-do-you-specify-when-access-should-be-granted-to-resources-when-selling-subscriptions'
    }
  }
}
